<template>
  <div>
    <div class="w-11/12 mx-auto md:w-full">
      <div
        class="text-center mb-8 custom-color-neutral text-zt-lg"
      >{{ $t('message.licenseComponent.licenseBox.optionalTitle') }}</div>
      <div>
        <v-menu
          v-if="state.config.periodo_liquidacion"
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              solo
              :value="formatedLiqPeriod"
              :label="$t('message.licenseComponent.licenseBox.liqPeriod')"
              append-icon="event"
              readonly
              v-on="on"
              data-vs-textfield="liqperiod" 
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="vuetifyLocale"
            no-title
            type="month"
            v-model="liqPeriod"
            @input="menu3 = false"
            data-vs-datepicker="liqperiodDatePicker" 
          ></v-date-picker>
        </v-menu>
        <v-select
          solo
          v-if="state.config.francos_rotativos && state.diasASolicitar != ''"
          class="mt-8"
          color="#FFFFFF"
          :items="dateRangeArray"
          @change="addFranco"
          :label="$t('message.licenseComponent.licenseBox.francos')"
          data-vs-select="francos" 
        ></v-select>
      </div>
    </div>
    <div class="w-full flex flex-wrap mx-auto mt-4 md:mt-2" v-if="francosArray.length > 0">
      <zt-chip
        v-for="(franco, index) in francosArray"
        :key="index"
        @click:close="removeFranco(franco)"
        closable
        outline
        class="bg-chip w-3/5 md:w-2/5"
        data-vs-chip="removeFranco" 
      >{{ franco }}</zt-chip>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Licenses from "@/apiClient/Licenses"
import { mapGetters } from "vuex"

export default {
  inject: ['state', 'mutations'],
  props: {
    tiposLic: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      licenses: Licenses,
      menu3: false,
      liqPeriod: this.state.request.periodoLiq,
      francosArray: this.state.request.francos,
      dateRangeArray: this.state.dateRangeArray
    }
  },
  created() {
    this.licenses = new Licenses()
  },
  watch: {
    liqPeriod(newVal, oldVal) {
      this.mutations.addParamToRequest({periodoLiq: newVal})
    },
    francosArray(newVal, oldVal) {
      this.mutations.addParamToRequest({francos: newVal})
    },
    dateRangeArray() {
      this.mutations.setDateRangeArray(this.dateRangeArray)
    }
  },
  computed: {
    formatedLiqPeriod() {
      return this.state.request.periodoLiq
        ? moment(this.state.request.periodoLiq).format('MM/YYYY')
        : ''
    },
    ...mapGetters({
      locale: 'getLocale'
    }),
    vuetifyLocale() {
      return this.locale === 'br' ? 'pt' : 'es'
    }
  },
  methods: {
    addFranco(value) {
      //Agrego el franco al array de francos
      this.francosArray.push(value)
      //Elimino el franco del array del select de francos
      for (var i = 0; i < this.dateRangeArray.length; i++) {
        if (this.dateRangeArray[i] === value) {
          this.dateRangeArray.splice(i, 1)
        }
      }
      this.recalculateDays(this.francosArray)
    },
    removeFranco(value) {
      //Elimino el franco del array de francos seleccionados
      for (var i = 0; i < this.francosArray.length; i++) {
        if (this.francosArray[i] === value) {
          this.francosArray.splice(i, 1)
        }
      }
      //Agrego el franco al array del select de francos
      this.dateRangeArray.push(value)
      this.recalculateDays(this.francosArray)
    },
    recalculateDays(francos) {
      this.licenses
        .calculateDays(
          moment(this.state.request.fechaDesde, 'DD/MM/YYYY').format('DD/MM/YYYY'),
          moment(this.state.request.fechaReingreso, 'DD/MM/YYYY').format('DD/MM/YYYY'),
          this.tiposLic.selected,
          francos
        )
        .then(response => {
          this.mutations.setDiasASolicitar(response.data.results.data[0])
          this.mutations.setDiasASolicitarValid(true)
        })
        .catch(err => {
          this.mutations.setDiasASolicitarValid(false)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.bg-chip {
  background-color: white !important;
}
</style>